import React from 'react';
import {
  Breadcrumb, Button, Card, Col, Layout, Row, Typography,
} from 'antd';
import {
  DndContext,
  DragOverlay,
} from '@dnd-kit/core';
import PropTypes from 'prop-types';
import { PlusOutlined } from '@ant-design/icons';

import TicketsColumn from './nested/TicketsColumn';
import useTicketsIndex from './hooks/useTicketsIndex';
import EditModal from './nested/EditModal';
import CreateModal from './nested/CreateModal';

const TicketsIndex = ({
  breadcrumbsItems = [],
  initialTickets = [],
  availableUsersOptions = [],
  availableBoardsOptions = [],
}) => {
  const {
    newTickets,
    inProgressTickets,
    doneTickets,
    activeTicket,
    editingTicket,
    colorBgContainer,
    borderRadiusLG,
    isEditModalOpen,
    isCreateModalOpen,
    handleEditTicket,
    handleEditTicketFinish,
    handleCreateTicket,
    handleCreateTicketFinish,
    dndContextSensors,
    contextHolder,
    handleDragStart,
    handleDragEnd,
    handleDragCancel,
  } = useTicketsIndex({ initialTickets });

  return (
    <div className="container">
      {contextHolder}
      <Breadcrumb style={{ margin: '16px 0' }} items={breadcrumbsItems} />
      <Layout
        style={{ padding: '24px 0', background: colorBgContainer, borderRadius: borderRadiusLG }}
      >
        <Layout.Content style={{ padding: '0 48px' }}>
          <div
            style={{
              background: colorBgContainer,
              minHeight: 280,
              padding: 24,
              borderRadius: borderRadiusLG,
            }}
          >
            <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
              <Col>
                <Typography.Title style={{ margin: 0 }}>Заявки</Typography.Title>
              </Col>
              <Col>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={handleCreateTicket}
                >
                  Створити заявку
                </Button>
              </Col>
            </Row>
            <DndContext
              sensors={dndContextSensors}
              onDragStart={handleDragStart}
              onDragEnd={handleDragEnd}
              onDragCancel={handleDragCancel}
            >
              <Row gutter={20}>
                <Col span={8}>
                  <TicketsColumn
                    title={`Нові (${newTickets.length})`}
                    id="new"
                    onEditTicket={handleEditTicket}
                    activeDraggableTicket={activeTicket}
                    tickets={newTickets}
                  />
                </Col>
                <Col span={8}>
                  <TicketsColumn
                    title={`В роботі (${inProgressTickets.length})`}
                    id="in_progress"
                    onEditTicket={handleEditTicket}
                    activeDraggableTicket={activeTicket}
                    tickets={inProgressTickets}
                  />
                </Col>
                <Col span={8}>
                  <TicketsColumn
                    title={`Завершені (${doneTickets.length})`}
                    id="done"
                    onEditTicket={handleEditTicket}
                    activeDraggableTicket={activeTicket}
                    tickets={doneTickets}
                  />
                </Col>
              </Row>
              <DragOverlay>
                {activeTicket ? (
                  <Card title={activeTicket.title} style={{ margin: 10 }}>
                    {activeTicket.description}
                  </Card>
                ) : null}
              </DragOverlay>
            </DndContext>
            <EditModal
              editingRow={editingTicket}
              isOpen={isEditModalOpen}
              availableUsersOptions={availableUsersOptions}
              availableBoardsOptions={availableBoardsOptions}
              onClose={handleEditTicketFinish}
            />
            <CreateModal
              isOpen={isCreateModalOpen}
              availableUsersOptions={availableUsersOptions}
              availableBoardsOptions={availableBoardsOptions}
              onClose={handleCreateTicketFinish}
            />
          </div>
        </Layout.Content>
      </Layout>
    </div>

  );
};

TicketsIndex.propTypes = {
  breadcrumbsItems: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })),
  initialTickets: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    number: PropTypes.string.isRequired,
    status: PropTypes.oneOf(['open', 'in_progress', 'closed']),
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    authorId: PropTypes.number.isRequired,
    authorName: PropTypes.string.isRequired,
  })),
  availableUsersOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
  })),
  availableBoardsOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
  })),
};

export default TicketsIndex;
